export const DEFAULT_CONTENT = {
    branding: {
        name: "KA Academy",
        tagline: "Sağlam zehin, Sağlam gələcək!",
        logoUrl:
            "https://customer-assets.emergentagent.com/job_9b88c520-3969-4ed0-b133-f720ea476878/artifacts/q5f1levr_image.png",
    },
    social: {
        whatsapp: "994703940304",
        instagram: "https://instagram.com/kaacademy.az",
        tiktok: "https://tiktok.com/@kaacademy.az",
        facebook: "",
    },
    hero: {
        eyebrow: "KA ACADEMY",
        title: "Sağlam zehin,\nsağlam gələcək.",
        subtitle:
            "Premium tədris akademiyası — şagirdlərimizi əvvəlcə psixoloqumuzla tanış edirik, sonra fərdi proqram qururuq.",
        ctaPrimary: "Qeydiyyatdan keç",
        ctaSecondary: "WhatsApp ilə yaz",
        typewriter: [
            "Hello.",
            "How are you?",
            "Let's speak English.",
            "Practice every day.",
            "You can do this.",
        ],
    },
    pillar: {
        eyebrow: "Fərqli yanaşma",
        title: "Əvvəl psixoloq,\nsonra tədris.",
        body:
            "Hər şagirdimiz öyrənməyə başlamazdan əvvəl peşəkar psixoloqumuzla görüşür. Onun emosional vəziyyəti, motivasiyası və öyrənmə tipi müəyyən edilir — yalnız bundan sonra fərdi tədris planı qurulur.",
        steps: [
            {
                id: "p1",
                step: "01",
                title: "Tanışlıq və qiymətləndirmə",
                description:
                    "Şagird və valideynlə görüş; akademik və emosional səviyyənin müəyyən edilməsi.",
            },
            {
                id: "p2",
                step: "02",
                title: "Psixoloji konsultasiya",
                description:
                    "Peşəkar psixoloqumuzla fərdi seans — motivasiya, öyrənmə tipi və qarşılaşan çətinliklər araşdırılır.",
            },
            {
                id: "p3",
                step: "03",
                title: "Fərdi tədris planı",
                description:
                    "Müəllim heyətimiz və psixoloq birgə şagirdə uyğun proqram tərtib edir.",
            },
            {
                id: "p4",
                step: "04",
                title: "Davamlı dəstək",
                description:
                    "Hər ay valideyn-müəllim-psixoloq görüşü ilə inkişaf izlənilir.",
            },
        ],
    },
    courses: [
        {
            id: "c1",
            title: "Buraxılış imtahanlarına hazırlıq",
            level: "11-ci sinif",
            description:
                "Bütün fənlər üzrə intensiv hazırlıq — sınaq imtahanları, fərdi izləmə.",
            icon: "GraduationCap",
        },
        {
            id: "c2",
            title: "İngilis dili",
            level: "A1 — C1",
            description:
                "Speaking, writing, grammar — natiq mühitində praktiki dərslər.",
            icon: "Languages",
        },
        {
            id: "c3",
            title: "Riyaziyyat və fizika",
            level: "5–11 sinif",
            description:
                "Möhkəm məntiqi bazanın qurulması və olimpiada hazırlığı.",
            icon: "Calculator",
        },
        {
            id: "c4",
            title: "İbtidai sinif hazırlığı",
            level: "1–4 sinif",
            description:
                "Məktəbəqədər hazırlıq və ibtidai siniflər üçün hərtərəfli dəstək.",
            icon: "BookOpen",
        },
        {
            id: "c5",
            title: "SAT və beynəlxalq imtahanlar",
            level: "IELTS · TOEFL · SAT",
            description:
                "Beynəlxalq sertifikatlara müəllim nəzarətində hazırlıq.",
            icon: "Globe",
        },
        {
            id: "c6",
            title: "Olimpiada hazırlığı",
            level: "Respublika · Beynəlxalq",
            description:
                "Akademik olimpiadalara güclü, dərinləşdirilmiş hazırlıq proqramı.",
            icon: "Trophy",
        },
    ],
    summer: {
        eyebrow: "Yay proqramı",
        title: "Yayı boş keçirmə —\nfərqlə başla.",
        body:
            "İyun–avqust ayları üçün xüsusi proqram: növbəti tədris ilinə güclü hazırlıq, dil kursları və yaradıcı emalatxanalar.",
        highlights: [
            "İntensiv repetitor dərsləri",
            "İngilis dili immersion qrupları",
            "Yaradıcı emalatxanalar (rəsm, debate, public speaking)",
            "Psixoloq dəstəyi və motivasiya seansları",
            "Həftəlik açıq hava aktivləri",
        ],
        image:
            "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1400&q=80",
    },
    teachers: [
        {
            id: "t1",
            name: "Kamran Əliyev",
            role: "Riyaziyyat müəllimi",
            bio: "15 illik tədris təcrübəsi. Riyaziyyat olimpiada hazırlıq mütəxəssisi.",
            image:
                "https://images.unsplash.com/photo-1758685734511-4f49ce9a382b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHx0ZWFjaGVyJTIwcG9ydHJhaXQlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzc4NTc2MTU3fDA&ixlib=rb-4.1.0&q=85",
        },
        {
            id: "t2",
            name: "Aysel Quliyeva",
            role: "İngilis dili müəllimi",
            bio: "IELTS rəsmi mütəxəssisi. 10 illik tədris təcrübəsi.",
            image:
                "https://images.unsplash.com/photo-1584554376766-ac0f2c65e949?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHx0ZWFjaGVyJTIwcG9ydHJhaXQlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzc4NTc2MTU3fDA&ixlib=rb-4.1.0&q=85",
        },
        {
            id: "t3",
            name: "Rəşad Hüseynov",
            role: "Fizika müəllimi",
            bio: "Bakı Dövlət Universitetinin məzunu. Olimpiada mütəxəssisi.",
            image:
                "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&h=600&fit=crop",
        },
        {
            id: "t4",
            name: "Nigar Məmmədova",
            role: "Psixoloq",
            bio: "Klinik psixologiya magistri. Uşaq və yeniyetmə motivasiyası üzrə mütəxəssis.",
            image:
                "https://images.unsplash.com/photo-1580894732444-8ecded7900cd?w=600&h=600&fit=crop",
        },
    ],
    gallery: [
        {
            id: "g1",
            url: "https://images.pexels.com/photos/8423012/pexels-photo-8423012.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
            caption: "Müasir sinif otaqları",
        },
        {
            id: "g2",
            url: "https://images.pexels.com/photos/6283211/pexels-photo-6283211.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
            caption: "Qrup dərsləri",
        },
        {
            id: "g3",
            url: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=940&q=80",
            caption: "Şagird seminarları",
        },
        {
            id: "g4",
            url: "https://images.unsplash.com/photo-1497486751825-1233686d5d80?auto=format&fit=crop&w=940&q=80",
            caption: "Mükafatlandırma mərasimləri",
        },
        {
            id: "g5",
            url: "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?auto=format&fit=crop&w=940&q=80",
            caption: "Akademik mühit",
        },
        {
            id: "g6",
            url: "https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=940&q=80",
            caption: "Kitabxana",
        },
    ],
    reviews: {
        eyebrow: "Valideyn rəyləri",
        title: "Şagirdlərimizin valideynləri\nbizim haqqımızda.",
        items: [
            {
                id: "r1",
                name: "Lalə xanım",
                relation: "Aydanın anası, 11-ci sinif",
                rating: 5,
                text:
                    "Qızım buraxılış imtahanından əvvəl çox stres keçirirdi. Psixoloji dəstək və müəllimlərin fərdi yanaşması ilə özünə inamı qayıtdı, 657 bal topladı. Çox təşəkkür edirik!",
            },
            {
                id: "r2",
                name: "Elnur bəy",
                relation: "Murad'ın atası, 9-cu sinif",
                rating: 5,
                text:
                    "İlk dəfə bir akademiyada psixoloqla ciddi görüş gördüm. Övladımın motivasiyası tamamilə dəyişdi. Riyaziyyatdan beş aldıq.",
            },
            {
                id: "r3",
                name: "Səbinə xanım",
                relation: "Leylanın anası, ibtidai sinif",
                rating: 5,
                text:
                    "Premium xidmət — kiçik qruplar, peşəkar müəllimlər, valideynlə daimi əlaqə. Hər ay görüşürük və qızımın inkişafını izləyirik.",
            },
            {
                id: "r4",
                name: "Tural bəy",
                relation: "Aysunun atası, IELTS hazırlığı",
                rating: 5,
                text:
                    "Qızım IELTS-də 7.5 topladı. Müəllim sadəcə tədris etmir — emosional vəziyyəti də nəzərə alır. Bu mənim üçün ən böyük fərqdir.",
            },
        ],
    },
    contact: {
        eyebrow: "Əlaqə və qeydiyyat",
        title: "Övladınız üçün ilk addımı atın.",
        body:
            "Qeydiyyat formasını doldurun və ya birbaşa WhatsApp üzərindən bizimlə əlaqə saxlayın. Bütün məlumat konfidensialdır.",
        phone: "70 394 03 04",
        email: "info@kaacademy.az",
        address: "Bakı şəhəri, Azərbaycan",
        workingHours: "B.e – Şənbə: 09:00 – 19:00",
        mapEmbed: "",
    },
    seo: {
        title: "KA Academy — Sağlam zehin, sağlam gələcək",
        description:
            "Premium tədris akademiyası — Bakı. Buraxılış imtahanlarına hazırlıq, dil kursları, fərdi psixoloji dəstək. Əvvəl psixoloq, sonra tədris.",
        keywords:
            "ka academy, kaacademy, tədris akademiyası, repetitor Bakı, buraxılış imtahanı hazırlıq, IELTS Bakı, ingilis dili kursu, psixoloji dəstək, yay proqramı, KA Academy Azərbaycan",
    },
};

export const SECTION_KEYS = [
    "branding",
    "social",
    "hero",
    "pillar",
    "courses",
    "summer",
    "teachers",
    "gallery",
    "reviews",
    "contact",
    "seo",
];
